import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role } from './../../../core/models/user-management/role';

@Component({
  selector: 'app-add-role-dialog',
  templateUrl: './add-role-dialog.component.html',
  styleUrls: ['./add-role-dialog.component.scss']
})
export class AddRoleDialogComponent implements OnInit {
  isDisabled = '';

  constructor(@Inject(MAT_DIALOG_DATA) public roleObj: Role) { }

  ngOnInit(): void { }
}
